import React, { useState } from 'react';
import useAdStatus from 'hooks/marketing/useAdStatus';
import useBudgetInfo from 'hooks/marketing/useBudgetInfo';
import CampaignIntro from './CampaignIntro';
import CampaignSetup from './CampaignSetup';

type Props = {
    isReadOnly: boolean;
    isGroupPractice: boolean;
};

const SoloCampaignSetup: React.FC<Props> = ({ isReadOnly, isGroupPractice }) => {
    const [adStatus] = useAdStatus();
    const [budgetInfo, budgetStatus, , refetchBudget] = useBudgetInfo();
    const [setupRevealed, setSetupRevealed] = useState(false);

    if (!adStatus.joinedAt && !setupRevealed) {
        return <CampaignIntro onSetupClick={() => setSetupRevealed(true)} />;
    }

    return (
        <CampaignSetup
            hasJoinedProListing={adStatus.hasJoinedAdSystem}
            isPaused={budgetStatus.isPaused}
            isReadOnly={isReadOnly}
            isGroupPractice={isGroupPractice}
            budgetInfo={budgetInfo}
            budgetStatus={budgetStatus}
            refetchBudget={refetchBudget}
        />
    );
};

export default SoloCampaignSetup;
